export default {"src":"/_next/static/media/karnataka.4c1e7ce8.svg","height":336,"width":402,"blurWidth":0,"blurHeight":0};